<app-search-input
    [placeholder]="translation.getText('search_tool', 'placeholder_simple')"
    [options]="searchOptions()"
    (hoveredValue)="selectSection($event)"
    (filterValues)="filterSections($event)"
    (updatedValue)="navigateToSection($event)"
/>
